import { Moon, Sun, Loader2 } from "lucide-react";
import { useTheme } from "../context/ThemeContext";
import { useState } from "react";
import { startTransition } from "react";


const ThemeToggle = ({ className = "" }) => {
  const { theme, toggleTheme } = useTheme();
  const [loading, setLoading] = useState(false);
  const isDark = theme === "dark"

  const handleToggle = () => {
    startTransition(() => {
    toggleTheme();
    });
  };

   return (
    <button
      onClick={handleToggle}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
      className={className}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "2px",
        padding: "3px",
        borderRadius: "999px",
        border: "1px solid var(--border)",
        background: isDark
          ? "linear-gradient(135deg, rgba(99,102,241,0.2), rgba(168,118,223,0.2))"
          : "linear-gradient(135deg, rgba(251,191,36,0.15), rgba(251,146,60,0.15))",
        cursor: "pointer",
        transition: "all 0.25s ease",
        width: "56px",
        height: "28px",
        position: "relative",
        flexShrink: 0,
      }}
    >
      {/* Sliding pill indicator */}
      <span
        style={{
          position: "absolute",
          left: "3px",
          transform: isDark ? "translateX(26px)" : "translateX(0)",
          width: "22px",
          height: "22px",
          borderRadius: "50%",
          background: isDark
            ? "linear-gradient(135deg, #6366f1, #a876df)"
            : "linear-gradient(135deg, #818cf8, #6366f1)",
          transition: "transform 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
          boxShadow: isDark
            ? "0 2px 8px rgba(99,102,241,0.4)"
            : "0 2px 8px rgba(99,102,241,0.35)",
        }}
      />

      {/* Sun icon */}
       <span style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "22px",
        height: "22px",
        zIndex: 1,
        color: !isDark ? "#fff" : "var(--muted-foreground)",
        transition: "color 0.25s ease",
      }}>
        <Sun size={12} />
      </span>

      {/* Moon icon */}
      <span style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "22px",
        height: "22px",
        zIndex: 1,
        color: isDark ? "#fff" : "var(--muted-foreground)",
        transition: "color 0.25s ease",
      }}>
        <Moon size={12} style={{ marginLeft: "5px" }} />
      </span>
    </button>
  );
};

export default ThemeToggle;